import Parser, { HTMLReactParserOptions } from "html-react-parser";
import lodash from "lodash";

export function toReact(
  html: string,
  options?: HTMLReactParserOptions["replace"],
  replaceNewLines = false
) {
  if (!html) return null;

  const safeHtml = sanitizeHTMLTags(html);
  const defaultOptions: HTMLReactParserOptions["replace"] = function (node) {
    if (
      lodash.get(node, "name") === "a" &&
      lodash.get(node, "type") === "tag"
    ) {
      (node as any).attribs["target"] = "_blank";
    }
    return node;
  };

  const normalizedHtml = replaceNewLines
    ? safeHtml.replace(/\n/g, "<br />")
    : safeHtml;

  return Parser(normalizedHtml, { replace: options || defaultOptions });
}

export function strip(html: string) {
  return html.replace(/(<([^>]+)>)/gi, "");
}

function sanitizeHTMLTags(html: string): string {
  return html.replace(/<\/?([^\s>\/]+@[^>]+)>/g, "");
}
